<template>
    <div :class="['hle-boq-builder-page boq-builder-page', { 'hle-boq-builder-page--deluxe': isDeluxeLayout }]">
     <BreadcrumbsProject
        v-if="!isDeluxeLayout"
        :breadcrumbs="[
            {
                link : dotnetUrl +'/project/list',
                title : $t('Projects'),
                isRouterLink: false
            },
            {
                link : projectUrl +'/Project/' + projectInfo._id,
                title : (projectInfo.projectNumber || '-') +' ' + (projectInfo.projectName || ''),
                isRouterLink: false
            },
            {
                link : '/boq/' + projectInfo._id,
                title : $t('Bill of Quantities'),
                isRouterLink: true
            },
            {
                link : '/boq/builder/' + boqItem._id,
                title : (boqItem.name || '-') ,
                isRouterLink: true
            }
        ]"
    ></BreadcrumbsProject>
    <StepItem2
        :active-index="isDeluxeLayout ? 1 : null"
        :deluxe="isDeluxeLayout"
    ></StepItem2>
    <div
        v-if="isDeluxeLayout"
        class="deluxe-project-back"
    >
        <router-link v-if="boqListProjectId" :to="{ name: 'Boq', params: { id: boqListProjectId } }">
            <i class="fa-solid fa-chevron-left"></i> {{ $t('Back to Bill of Quantity') }}
        </router-link>
        <a v-else href="#" @click.prevent="$router.back()">
            <i class="fa-solid fa-chevron-left"></i> {{ $t('Back to Bill of Quantity') }}
        </a>
    </div>
    <div class="card hle-bidding-card hle-boq-builder-card">
        <div class="card-header bg-white hle-boq-builder-card__header">
            <div class="d-flex justify-content-between hle-boq-builder-header">
                <div class="d-flex justify-content-center align-items-center hle-boq-builder-title">
                    <span class="hle-estimate-eyebrow">{{ $t('Bill of Quantities') }}</span>
                    <h4 class="text-capitalize">{{ boqItem.name || '-' }}</h4>
                </div>
                <div class="hle-boq-builder-actions">
                    <button type="button" class="btn btn-primary hle-boq-builder-action hle-boq-builder-action--primary" @click="SendForApproval"
                    v-if="boqItem.approvalStage !=ApprovalStageBoq.FOR_APPROVAL &&
                    permission.indexOf(ModuleActionList.BOQ_EDIT) >-1 && !IsApproved" 
                    ><i class="fa-solid fa-file-pen"></i> {{$t('Send For Approval')}}</button>

                    <ButtonTemplateDownloader
                    v-if="!IsQuotationPublished"
                    standard
                    group-class="hle-boq-builder-template-group"
                    button-class="hle-boq-builder-action hle-boq-builder-action--template"
                    />
                    <button class="btn btn-default hle-boq-builder-action hle-boq-builder-action--utility"
                    data-bs-toggle="modal" data-bs-target="#ModalImportBoq"
                    v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1 && !IsApproved"
                    @click="OpenImportModal"
                    :title="$t('Import File')"><i class="fa-solid fa-file-import"></i> {{$t('Import')}}  </button>
                    <button class="btn btn-default hle-boq-builder-action hle-boq-builder-action--utility" :title="$t('Export to File')"
                    data-bs-toggle="modal" data-bs-target="#BoqExportBoqList"
                    @click="()=>{ exportTemplateType= 0}"
                    ><i class="fa-solid fa-file-export"></i> {{ $t('Export') }} </button>
                    
                    <router-link :title="$t('Print Bill of Quantity')" :to="{name : 'BoqItemsPrint' , params : {id : boqId}}"  class="btn btn-default hle-boq-builder-action hle-boq-builder-action--print"><i class="fa-solid fa-print"></i> {{ $t('Print') }}</router-link>
                </div>
            </div>
        </div>
        <div class="card-body hle-boq-builder-card__body">
            <div class="hle-boq-builder-alert hle-boq-builder-alert--approval" role="alert" v-if="processItemData">
                <span class="hle-boq-builder-alert__icon"><i class="fas fa-info-circle"></i></span>
                <div class="hle-boq-builder-alert__content">
                    <strong>{{ $t('Bill of Quantities') }}</strong>
                    <span>{{ $t('Bill of Quantity Module.This Bill of Quantity is ongoing approval') }}.</span>
                </div>
                <router-link class="hle-boq-builder-alert__action" :to="{name : 'Review', params : {id : processItemData._id}}">
                    {{ $t('Go to Approval') }}
                    <i class="fa-solid fa-arrow-right"></i>
                </router-link>
            </div>
            <div class="hle-boq-builder-alert hle-boq-builder-alert--warning" role="alert" v-if="haveUnassignedLineItems">
                <span class="hle-boq-builder-alert__icon"><i class="fas fa-info-circle"></i></span>
                <div class="hle-boq-builder-alert__content">
                    <strong>{{ $t('Bill of Quantities') }}</strong>
                    <span>{{ $t('This Bill of Quantity has an unassigned Line items') }}.</span>
                </div>
                <router-link class="hle-boq-builder-alert__action" :to="{name : 'BoqBuilderUnassigneds', params : {id : boqItem._id}}">
                    {{ $t('Assign Line Items') }}
                    <i class="fa-solid fa-arrow-right"></i>
                </router-link>
            </div>
            <div class="d-flex justify-content-between mb-2 hle-boq-builder-meta">
                <div>
                    <span v-if="boqItem.reference">
                        <small class="text-muted">{{ $t('Reference') }}:</small>
                        <router-link :to="{name : 'BoqQuotation', params : {id : boqItem.reference._id} }" 
                         class="small text-primary fw-bold">
                         {{boqItem.reference.quotationNumber}} {{boqItem.reference.quotationName}} <span v-if="IsQuotationApproved" class="text-success">({{$t('Published')}})</span>
                        </router-link>
                    </span>
                </div>
                <div class="btn-group">
                    <span :class="['badge hle-bidding-status-pill', GetBoqStatusClass(boqItem.approvalStage)]">
                        {{ApprovalStageBoqObj[boqItem.approvalStage-1].name}}
                        {{  (boqItem.haveProcuredSections ? `(${$t('In Procurement')})` : '')}}
                    </span>
                    
                </div>
            </div>
            <div class="d-flex justify-content-between mb-1">
                <div>
                    
                </div>
                <div class="hle-boq-builder-sequence-actions" v-if="haveMoved">
                    
                    <button class="btn hle-boq-builder-action hle-boq-builder-action--cancel" @click="CancelSaveSequence">{{ $t('Cancel') }}</button>
                    <button class="btn hle-boq-builder-action hle-boq-builder-action--primary" @click="SaveSequences"><i class="fa-solid fa-list-ol"></i> {{ $t('Save Sequence') }}</button>
                </div>
            </div>
            <div class="hle-boq-builder-table-wrap">
                <div class="d-flex fw-bold hle-boq-builder-table-row hle-boq-builder-table-row--head" style="background-color: #F5F6FA;" >
                    <div class=" p-2 border border-end-0 " style="width: 5%;"></div>
                    <div class=" p-2 border border-end-0" style="width: 30%;">{{$t('Section')}}</div>
                    <div class="p-2 border border-end-0 " style="width: 12%;">{{ $t('Total Cost') }} ({{boqItem.currencyId?.sign}})</div>
                    <div class=" p-2 border border-end-0" style="width: 12%;">{{$t('Total Sell')}} ({{boqItem.currencyId?.sign}})</div>
                    <div class=" p-2 border border-end-0" style="width: 12%;">{{ $t('GP Total') }} ({{boqItem.currencyId?.sign}})</div>
                    <div class=" p-2 border border-end-0" style="width: 12%;">{{$t('GP')}} %</div>
                    <div class=" p-2 border" style="width: 17%;"></div>
                    
                </div>
                <div class="small p-2 border border-top-0 hle-boq-builder-add-row" style="min-height: 37.8px;" v-if="!IsQuotationPublished">
                    <div class=" text-end "  >
                        <small class="fw-bold hle-boq-builder-add-section" @click="OpenAddNewSection" role="button" data-bs-toggle="modal" data-bs-target="#BoQAddMainSectionModal">
                            <i class="fa-solid fa-plus"></i> {{$t('Add Main Section')}}
                        </small>
                    </div>
                </div>
                <div class="" v-if="sectionList.length==0">
                    <div class="text-center p-2 border border-top-0 hle-boq-builder-empty">
                        <span class="fw-bold">{{$t('No data Found')}}</span>
                    </div>
                </div>
                <div class="parent hle-boq-builder-table-body">
                    <BoqSectionRow :OpenRename="OpenRename" :BoqItem="boqItem" :OpenAddNewSubSection="OpenAddNewSubSection" :DeleteMain="DeleteMain" :SectionList="sectionList" :Level="1"
                    :OnEnd="OnEnd" :OpenMarkUp="OpenMarkUp" :IsApproved="boqItem.approvalStage === ApprovalStageBoq.APPROVED" :ProcureSection="OpenProcureSection"
                    :ReferenceIndex="boqItem.indexReference" :IsQuotationApproved="IsQuotationApproved" :CanProcureSection="CanProcureSection" >
                    
                    </BoqSectionRow>
                </div>
                <div class="d-flex small fw-bold bg-light-primary hle-boq-builder-total-row" >
                    <div class="  p-2 border border-end-0 border-top-0" style="width: 5%;">
                    </div>
                    <div class=" text-end p-2 border border-end-0 border-top-0 " :style="{width: BoqBuilderColumSizes.DESCRIPTION}">
                        <span class="fw-bold text-capitalize">{{ $t('Overall Total') }} </span>
                    </div>
                    <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.COST_TOTAL}" v-html="ReformatNumberHtml(overAllTotal.costTotal)">
                    </div>
                    <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.SELL_TOTAL}" v-html="ReformatNumberHtml(overAllTotal.sellTotal)">
                    </div>
                    <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.GP}" v-html="ReformatNumberHtml(overAllTotal.gp)">
                    </div>
                    <div class=" p-2 border border-end-0 border-top-0 text-end" :style="{width: BoqBuilderColumSizes.GP_PERCENTAGE}" v-html="ReformatNumberHtml(overAllTotal.gpPercentage,0,2)">
                    </div>
                    <div class="p-2 border border-top-0" :style="{width: BoqBuilderColumSizes.ACTIONS}">
                    </div>
                </div>


            </div>
        </div>
    </div>
    <Modal idModal="RenameSectionModal" :headerTitle="$t('Update Section')" modalSize="modal-md" >
        <div class="form-group hle-section-modal-field">
            <label>
                {{ $t('Section Name') }}
                <span class="bidding-required-inline" v-if="!renameSection.name">({{ $t('Required').toLowerCase() }})</span>
            </label>
            <div class="hle-section-modal-input">
                <span class="hle-section-modal-input__icon">
                    <i class="fa-solid fa-layer-group"></i>
                </span>
                <input class="form-control" :placeholder="$t('Section Name')" v-model="renameSection.name" />
            </div>
            <small class="text-warning" v-if="isActionClicked && !renameSection.name">{{ $t('Required') }}</small>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeRenameSectionModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="!renameSection.name" @click="RenameSection"><i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i> {{$t('Update')}}</button>
        </template>
    </Modal>
    <Modal idModal="BoQAddMainSectionModal" :headerTitle="$t('Add Main Section')" modalSize="modal-md" >
        <div class="form-group hle-section-modal-field">
            <label>
                {{ $t('Section Name') }}
                <span class="bidding-required-inline" v-if="!isAddMainSectionReady">({{ $t('Required').toLowerCase() }})</span>
            </label>
            <div class="hle-section-modal-input">
                <span class="hle-section-modal-input__icon">
                    <i class="fa-solid fa-layer-group"></i>
                </span>
                <input class="form-control" :placeholder="$t('Section Name')" v-model="newSection.name" />
            </div>
            <small class="text-warning" v-if="isActionClicked && !isAddMainSectionReady">{{ $t('Required') }}</small>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeBoQAddMainSectionModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="!isAddMainSectionReady" @click="AddMainSection"><i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i> {{$t('Add')}}</button>
        </template>
    </Modal>
    <Modal idModal="BoQAddSubSectionModal" :headerTitle="$t('Add Sub Section')" modalSize="modal-md" >
        <div class="form-group hle-section-modal-field hle-section-modal-field--display">
            <label>{{$t('Main Section Name')}} </label>
            <div class="hle-section-modal-display">
                <span class="hle-section-modal-display__icon">
                    <i class="fa-solid fa-layer-group"></i>
                </span>
                <span class="hle-section-modal-display__value text-capitalize">{{ newSubSection.mainName || '' }}</span>
            </div>
        </div>
        <div class="form-group hle-section-modal-field">
            <label>
                {{$t('Sub Section Name')}}
                <span class="bidding-required-inline" v-if="!isAddSubSectionReady">({{ $t('Required').toLowerCase() }})</span>
            </label>
            <div class="hle-section-modal-input">
                <span class="hle-section-modal-input__icon">
                    <i class="fa-solid fa-diagram-project"></i>
                </span>
                <input class="form-control" :placeholder="$t('Section Name')" v-model="newSubSection.name" />
            </div>
            <small class="text-warning" v-if="isActionClicked && !isAddSubSectionReady">{{ $t('Required') }}</small>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeBoQAddSubSectionModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="!isAddSubSectionReady" @click="AddNewSubSection"><i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i> {{$t('Add')}}</button>
        </template>
    </Modal>
    <Modal idModal="BoQMarkUpUpdateModal" :headerTitle="$t('Update Section Mark Up')" modalSize="modal-md" >
        <div class="form-group hle-section-modal-field hle-section-modal-field--display">
            <label>{{ $t('Section Name') }} </label>
            <div class="hle-section-modal-display">
                <span class="hle-section-modal-display__icon">
                    <i class="fa-solid fa-layer-group"></i>
                </span>
                <span class="hle-section-modal-display__value text-capitalize">{{ markUpUpdate.name || '' }}</span>
            </div>
        </div>
        <div class="form-group hle-section-modal-field">
            <label>{{ $t('Mark Up') }} </label>
            <div class="hle-section-modal-input hle-section-modal-input--with-suffix">
                <span class="hle-section-modal-input__icon">
                    <i class="fa-solid fa-percent"></i>
                </span>
                <input type="number" class="form-control"  v-model="markUpUpdate.markUp" max="100" min="0"/>
                <span class="hle-section-modal-input__suffix">%</span>
            </div>
            <small class="text-warning" v-if="isActionClicked && (markUpUpdate.markUp < 0 || markUpUpdate.markUp > 100)">{{ $t('Required') }}</small>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeBoQMarkUpUpdateModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" @click="UpdateMarkUp"><i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i> {{$t('Save')}}</button>
        </template>
    </Modal>
    <ModalImportLineItems
    v-if="boqItem.projectId && permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
    ref="modalImportLineItem"
    :boqList="[]" :ResetData="RefreshAfterImport" :boqId="boqItem._id" :projectId="boqItem.projectId" />
    <Modal idModal="BoqExportBoqList" :headerTitle="$t('Export')"  >
        <div>
            <div class="form-group hle-section-modal-field">
                <label>
                    {{$t('Template')}}
                </label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-file-export"></i>
                    </span>
                <select class="form-select" v-model="exportTemplateType" :disabled="isExportRunning">
                    <option v-for="(item,key) in ExportTemplatesForExport" :key="key" :value="key">{{item}}</option>
                </select>
                </div>
            </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeBoqExportBoqList" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="isExportRunning" @click="ExportBoqList" >
                <i v-if="!isDeluxeLayout && !isExportRunning" class="fa-solid fa-file-arrow-down"></i>
                <span>{{ $t('Export') }}</span>
                <span v-if="isExportRunning" class="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>
                <span v-if="isExportRunning" class="visually-hidden" role="status">{{ $t('Loading') }}</span>
            </button>
        </template>
    </Modal>
    <button
        type="button"
        ref="openBoqProcureSectionModal"
        class="d-none"
        data-bs-toggle="modal"
        data-bs-target="#BoqProcureSectionModal"
        tabindex="-1"
        aria-hidden="true"
    ></button>
    <Modal idModal="BoqProcureSectionModal" :headerTitle="$t('Procure Section')" modalSize="modal-md">
        <div v-if="selectedSection">
            <div class="form-group hle-section-modal-field hle-section-modal-field--display">
                <label>{{ $t('Section Name') }}</label>
                <div class="hle-section-modal-display">
                    <span class="hle-section-modal-display__icon">
                        <i class="fa-solid fa-layer-group"></i>
                    </span>
                    <span class="hle-section-modal-display__value text-capitalize">{{ selectedSection.name || '' }}</span>
                </div>
            </div>
            <div class="form-group hle-section-modal-field">
                <label>{{ $t('Combine into Existing Trade Package?') }}</label>
                <div class="hle-section-modal-input">
                    <span class="hle-section-modal-input__icon">
                        <i class="fa-solid fa-boxes-stacked"></i>
                    </span>
                    <select class="form-select" v-model="selectedSection.existing">
                        <option value="false">{{ $t('No') }}</option>
                        <option value="true">{{ $t('Yes') }}</option>
                    </select>
                </div>
            </div>
            <div class="form-group hle-section-modal-field" v-if="selectedSection.existing === 'true'">
                <label>{{ $t('Trade Package') }}</label>
                <Select2
                    indexValue="id"
                    labelName="name"
                    :placeHolder="$t('Select Trade Package')"
                    :dataOptions="nonProcuredTradePackages"
                    v-model:optionValue="selectedSection.tradePackageId"
                    :willCapitalize="false"
                />
                <small class="text-warning" v-if="nonProcuredTradePackages.length === 0">
                    {{ $t('No data Found') }}
                </small>
            </div>
        </div>
        <template v-slot:actions>
            <button
                type="button"
                ref="closeBoqProcureSectionModal"
                :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'"
                data-bs-dismiss="modal"
            >{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button
                type="button"
                :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'"
                @click="ProcureSection"
                :disabled="isOnProcess || (selectedSection?.existing === 'true' && !selectedSection?.tradePackageId)"
            >
                <i v-if="!isDeluxeLayout" class="fa-solid fa-save"></i>
                {{ isOnProcess ? $t('Loading') : $t('Save') }}
            </button>
        </template>
    </Modal>
    </div>
</template>


<script>
import Modal  from '@/components/layout/Modal.vue'
import BoqSectionRow from '@/components/boq/BoqSectionRow.vue'
import ModalImportLineItems from '@/components/boq/ModalImportLineItems.vue'
import ButtonTemplateDownloader from '@/components/boq/ButtonTemplateDownloader.vue'
import { LinkList,ReformatNumberHtml, ApprovalStageBoqObj, ApprovalStageBoq, ModuleActionList, ExportTemplates, BoqBuilderColumSizes } from '@/helpers/utilities.js'
import 'dotenv/config'
import {GetNewBoqCreatorSections, AddNewBoqCreatorSection, UpdateNewBoqCreatorSectionName, GetItemsFromBoqByBits,
    DownloadBoqExport,ExportBoqFiveDLayout,ExportBoqCostXLayout,BoQItemExportForInternal, GetNonProcuredTradePackagesInProject,
    DeleteNewBoqCreatorSection, ProcureNewBoqCreatorSection, UpdateNewBoqCreatorSectionSequence, UpdateNewBoqCreatorSectionMarkUp} from '@/actions/boqActions.js'
import {GetProcessItemBoq} from '@/actions/projectActions.js'
import {mapActions, mapGetters} from 'vuex'
import BreadcrumbsProject  from '@/components/projectInformation/BreadcrumbsProject.vue'
import StepItem2 from '@/components/layout/StepItem2.vue'
import Select2 from '@/components/layout/Select2.vue'
export default { 
    name : 'BoqBuilder',
    components : {
        Modal, BoqSectionRow, BreadcrumbsProject,ModalImportLineItems, ButtonTemplateDownloader, StepItem2, Select2
    },
    mounted : async function(){
        const self = this

        self.boqItem = await self.GetBoqItemRun(self.boqId) 
        self.ChangeActiveLink(LinkList.BILL_OF_QUANTITIES)
        await self.GetProjectInfo(self.boqItem.projectId).catch()
        await self.ReloadData()
        if(self.boqItem.approvalStage==ApprovalStageBoq.FOR_APPROVAL){
            const processData = await GetProcessItemBoq(self.boqId).catch()
            self.processItemData = processData
        }
        self.ExportTemplatesForExport = [...ExportTemplates]
        self.ExportTemplatesForExport.push(self.$i18n.t('System Template (For Presentation)'))

        const getUnassingedLineItem = await GetItemsFromBoqByBits({
            page : 1,
            id :  self.boqId,
            costCode : '',
            area : '',
            skip : 0,
            take : 1
        })
        if(getUnassingedLineItem.length!=0){
            self.haveUnassignedLineItems = true
        }
    },
    computed :{
        ...mapGetters(['projectInfo','permission']),
        isDeluxeLayout(){
            return this.$route.meta.layout == 'deluxe'
        },
        boqListProjectId(){
            return this.boqItem.projectId || this.projectInfo._id || ''
        },
        isAddMainSectionReady(){
            return String(this.newSection.name || '').trim().length > 0
        },
        isAddSubSectionReady(){
            return String(this.newSubSection.name || '').trim().length > 0
        },
        IsQuotationPublished(){
            if(!this.boqItem.reference)
                return false
            else{
                return this.boqItem.reference.approvalStage === ApprovalStageBoq.PUBLISHED
            }
                
        },
        IsApproved(){
            return Number(this.boqItem.approvalStage) === ApprovalStageBoq.APPROVED
        },
        IsQuotationApproved(){
            const referenceStage = Number(this.boqItem.reference?.approvalStage)
            return [ApprovalStageBoq.APPROVED, ApprovalStageBoq.PUBLISHED].indexOf(referenceStage) > -1
        },
    },
    data(){
        return{
            nonProcuredTradePackages: [],
            ExportTemplatesForExport : [],
            exportTemplateType : 1,
            isExportRunning : false,
            haveUnassignedLineItems : false,
            processItemData : null,
            ApprovalStageBoqObj,
            ApprovalStageBoq,
            ModuleActionList,
            projectUrl : process.env.VUE_APP_PROJECT_URL,
            dotnetUrl : process.env.VUE_APP_DOTNET_URL,
            boqId : this.$route.params.id,
            boqItem : {
                approvalStage : 1
            },
            sectionList : [],
            overAllTotal : {},
            newSection : {},
            renameSection: {},
            newSubSection : {},
            markUpUpdate : {},
            isActionClicked :false,
            id : 3,
            subId : 2,
            draggableOptions: {
                group: 'nested',
            },
            showBreakdown : false,
            haveMoved : false,
            BoqBuilderColumSizes,
            selectedSection : null,
            isOnProcess : false,
        }
    },
    methods : {
        ...mapActions(['GetBoqItemRun','ChangeActiveLink', 'DeleteBoqPermanent','GetProjectInfo']),
        ReformatNumberHtml,
        GetBoqStatusClass(status){
            switch(Number(status)){
                case 1:
                case 2:
                case 3:
                    return 'hle-bidding-status-pill--pending'
                case 4:
                    return 'hle-bidding-status-pill--approval'
                case 5:
                case 8:
                    return 'hle-bidding-status-pill--approved'
                case 6:
                    return 'hle-bidding-status-pill--revision'
                default:
                    return 'hle-bidding-status-pill--neutral'
            }
        },
        async ReloadData(){
            const self = this
            const dataSections = await GetNewBoqCreatorSections(self.boqId) 
            self.sectionList = dataSections.sections
            self.overAllTotal = dataSections.overAllTotal
        },
        SendForApproval(){
            const self = this
            if(!self.sectionList || self.sectionList.length==0){
                self.$swal(
                    self.$i18n.t('Send For Approval'),
                    self.$i18n.t('Please add at least one section before sending this Bill of Quantity for approval.'),
                    'warning'
                )
                return
            }

            self.$router.push({name : 'BoqReviewerSetup', query : { boqId : self.boqItem._id} })
        },
        async HaveUnassigned(){
            const getUnassingedLineItem = await GetItemsFromBoqByBits({
                page : 1,
                id :  this.boqId,
                costCode : '',
                area : '',
                skip : 0,
                take : 1
            })
            this.haveUnassignedLineItems = getUnassingedLineItem.length!=0
        },
        async RefreshAfterImport(){
            await Promise.all([
                this.ReloadData(),
                this.HaveUnassigned()
            ])
        },
        OpenImportModal(){
            this.$refs.modalImportLineItem.ClearData()
        },
        OpenAddNewSection(){
            this.isActionClicked = false
            this.newSection = {} 
        },
        async AddMainSection(){
            const self = this
            const data = self.newSection
            
            self.isActionClicked = true
            if(!self.isAddMainSectionReady){
                return
            }
            self.isActionClicked = false

            const created = await AddNewBoqCreatorSection({
                boqId : self.boqId,
                name : String(data.name || '').trim(),
                level : 1,
                sequence : self.sectionList.length 
            })
            if(typeof created!=='object'){
                const isDuplicateSection = String(created).toLowerCase().includes('already exist')
                self.$swal({
                    icon : 'warning',
                    title : self.$i18n.t('Unable to Add Main Section'),
                    text : isDuplicateSection
                        ? self.$i18n.t('A main section with this name already exists. Please enter a different section name.')
                        : created,
                    confirmButtonText : self.$i18n.t('OK')
                })
                return
            }

            self.sectionList.push({
                id : created._id,
                name : data.name,
                level : 1,
                childs : []
            })
            self.$refs.closeBoQAddMainSectionModal.click()
        },
        OpenAddNewSubSection(element){
            this.isActionClicked = false
            this.newSubSection = {
                parentId : element.id,
                mainName : element.name,
                parent : element,
                level : element.level + 1
            }
        },
        async AddNewSubSection(){
            const self = this
            const data = self.newSubSection

            self.isActionClicked = true
            if(!self.isAddSubSectionReady){
                return
            }
            self.isActionClicked = false
            
            const created = await AddNewBoqCreatorSection({
                boqId : self.boqId,
                name : String(data.name || '').trim(),
                level : data.level,
                sequence : data.parent.childs.length,
                parent :  data.parent.id
            })
            if(typeof created!=='object'){
                const isDuplicateSection = String(created).toLowerCase().includes('already exist')
                self.$swal({
                    icon : 'warning',
                    title : self.$i18n.t('Unable to Add Sub Section'),
                    text : isDuplicateSection
                        ? self.$i18n.t('A sub section with this name already exists. Please enter a different section name.')
                        : created,
                    confirmButtonText : self.$i18n.t('OK')
                })
                return
            }

            data.parent.childs.push(
                {
                    id : created._id,
                    name : String(data.name || '').trim(),
                    level : data.level,
                    childs : []
                }
            )
            
            self.$refs.closeBoQAddSubSectionModal.click()
        },
        async OpenProcureSection(element){
            if(!this.CanProcureSection(element)) return;

            this.selectedSection = element;
            this.selectedSection.existing = "false";
            this.selectedSection.tradePackageId = '';
            this.$nextTick(()=>{
                this.$refs.openBoqProcureSectionModal?.click()
            })

            const getTrades = await GetNonProcuredTradePackagesInProject(this.boqItem.projectId)
            console.log(getTrades,'getTrades');
            this.nonProcuredTradePackages = getTrades;
        },
        async ProcureSection() {
            const self = this
            if(self.isOnProcess) return;
            const swalTitle = self.$i18n.t('Procure Section');
            const element = self.selectedSection;
            if(!element) return;
            if(!self.CanProcureSection(element)) {
                self.selectedSection = null;
                self.$refs.closeBoqProcureSectionModal?.click()
                return;
            }


            if(self.selectedSection.existing === 'true' && !self.selectedSection.tradePackageId) {
                self.$swal(swalTitle, self.$i18n.t('No trade package selected'), 'warning')
                return
            }

            const procureChildren = (childs) => {
                if(childs.length === 0) return;
                for(let x = 0; x < childs.length; x++) {
                    const c = childs[x]
                    c.forProcurement = true;
                    procureChildren(c.childs);
                }
            }

            self.isOnProcess = true;
            const procureResult = await ProcureNewBoqCreatorSection({id: self.selectedSection.id, tradePackageId: self.selectedSection.existing === 'true' ? self.selectedSection.tradePackageId : null, boqId: self.boqId })
            if(procureResult!='OK') {
                self.$swal(swalTitle, procureResult, 'warning')
                self.isOnProcess = false;
                return
            }

            element.forProcurement = true;
            procureChildren(element.childs)
            self.isOnProcess = false;
            self.$refs.closeBoqProcureSectionModal?.click()
        },
        SectionHasLineItems(section){
            if(!section) return false;

            const children = Array.isArray(section.childs) ? section.childs : [];
            if(children.length > 0){
                return children.some((child)=>this.SectionHasLineItems(child));
            }

            // The section API only returns `sum` for a leaf section that has
            // at least one assigned line item. A zero-value line item still
            // produces a sum object and must remain eligible for procurement.
            return !!section.sum;
        },
        CanProcureSection(section){
            if(!section) return false;

            const children = Array.isArray(section.childs) ? section.childs : [];

            // Main sections are containers and cannot be procured until they
            // contain a sub-section with at least one assigned line item.
            if(Number(section.level) === 1 && children.length === 0){
                return false;
            }

            return this.SectionHasLineItems(section);
        },
        DeleteMain(element,parent){
            const self = this

            const swalTitle = self.$i18n.t('Delete Section')
            self.$swal({
                title: swalTitle,
                text : element.name + " " + self.$i18n.t('Will be deleted'),
                showCancelButton: true,
                icon: 'warning',
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !self.$swal.isLoading(),
                preConfirm: () => DeleteNewBoqCreatorSection({id : element.id, boqId : self.boqId, level :element.level})
            }).then(async (res)=>{
                if(res.isConfirmed){
                    if(res.value=='OK'){
                        self.$swal(swalTitle,self.$i18n.t('Removed Successfully'),'success')
                        if(parent){
                            const getIndex = parent.childs.findIndex(u=>u.id==element.id)
                            if(getIndex!=-1){
                                parent.childs.splice(getIndex,1)
                            }
                        }else{
                            const getIndex = self.sectionList.findIndex(u=>u.id==element.id)
                            if(getIndex!=-1){
                                self.sectionList.splice(getIndex,1)
                            }
                        }

                        const getUnassingedLineItem = await GetItemsFromBoqByBits({
                            page : 1,
                            id :  self.boqId,
                            costCode : '',
                            area : '',
                            skip : 0,
                            take : 1
                        })
                        if(getUnassingedLineItem.length!=0){
                            self.haveUnassignedLineItems = true
                        }

                    }else{
                        self.$swal(swalTitle,res.value,'warning')
                    }
                }
            })
        },
        OpenRename(element){
            this.renameSection = {
                id : element.id,
                level : element.level,
                name : element.name,
                object : element
            }
        },
        async RenameSection(){
            const self = this
            const data = self.renameSection
            self.isActionClicked = true
            if(!data.name){
                return
            }
            self.isActionClicked = false

            const updated = await UpdateNewBoqCreatorSectionName({
                id : data.id,
                boqId : self.boqId,
                level : data.level,
                name : data.name
            })
            
            
            if(updated!='OK'){
                self.$swal(self.$i18n.t('Update Section'),updated,'warning')
                return
            }

            data.object.name = data.name

            self.$refs.closeRenameSectionModal.click()
        },
        OnDragEnd(e){
            // Check if the target is a parent or child element
            let isParent = e.to.classList.contains("parent")
            if (isParent) {
                return false
            }
        },
        OnEnd(){
            this.haveMoved = true
        },
        CancelSaveSequence(){
            window.location.reload()
        },
        async SaveSequences(){
            const self = this

            //get the rows
            const data = JSON.parse(JSON.stringify(self.sectionList))
            let toBeUpdated = []

            let duplicateList = []

            const LoopData = async (rows, parentId)=>{
                let promise  = []
                for(let x = 0; x < rows.length; x++ ){
                    let row = rows[x]

                    const haveDuplicates = rows.find(u=>u.name.toLowerCase().trim()==row.name.toLowerCase().trim() && u.id!=row.id)
                    if(haveDuplicates){
                        if(duplicateList.findIndex(u=>u.toLowerCase().trim()==row.name.toLowerCase().trim())==-1){
                            duplicateList.push(row.name)
                        }
                    }

                    if(row.sequence!=x || parentId!=row.parent){
                        toBeUpdated.push({
                            id : row.id,
                            name : row.name,
                            parent : parentId,
                            level : row.level,
                            sequence : x
                        })
                    }
                    row.sequence = x
                    row.parent = parentId
                    if(row.childs.length!=0){
                        promise.push(LoopData(row.childs,row.id))
                    }
                }
                await Promise.all(promise)
            }
            await LoopData(data)
            const titleSwal = self.$i18n.t('Save Sequence')

            if(duplicateList.length!=0){
                
                self.$swal(titleSwal,  self.$i18n.t('Section(s)') + ' ' + duplicateList.join(',') 
                + '  ' + self.$i18n.t('have identical names within their parent section'),'warning')
                return
            }

            if(toBeUpdated.length!=0){
                const updated = await UpdateNewBoqCreatorSectionSequence({
                    boqId : self.boqId,
                    sections : toBeUpdated
                })

                if(updated!='OK'){
                    self.$swal(titleSwal, updated,'warning')
                }else{
                    self.$swal(titleSwal, self.$i18n.t('Updated Successfully'),'success')
                    self.sectionList = data
                    self.haveMoved = false
                }


            }

        },
        OpenMarkUp(element){
            this.markUpUpdate = {
                id : element.id,
                name : element.name,
                markUp : 0,
            }
        },
        async UpdateMarkUp(){
            const self = this
            const data = self.markUpUpdate
            
            self.isActionClicked = true
            if(data.markUp < 0 || data.markUp > 100){
                return
            }
            self.isActionClicked = false

            const updated = await UpdateNewBoqCreatorSectionMarkUp({
                id : data.id,
                boqId : self.boqId,
                markUp : data.markUp
            })
            
            const swalTitle = self.$i18n.t('Update Section Mark Up')
            if(updated!='OK'){
                self.$swal(swalTitle,updated,'warning')
                return
            }
            self.$swal(swalTitle, self.$i18n.t('Updated Successfully'),'success')
            await self.ReloadData()


            self.$refs.closeBoQMarkUpUpdateModal.click()
        },
        async ExportBoqList(){
            if(this.isExportRunning){
                return
            }

            const boqId = this.$route.params.id
            const exportName = this.boqItem.name
            this.isExportRunning = true
            try{
                if(this.exportTemplateType===0){
                    await DownloadBoqExport(boqId, exportName +' export')
                }else if(this.exportTemplateType===1){
                    await ExportBoqFiveDLayout(boqId, exportName + ' FiveD-export')
                }else if(this.exportTemplateType===2){
                    await ExportBoqCostXLayout(boqId, exportName + ' costX-export')
                }else if(this.exportTemplateType===3){
                    await BoQItemExportForInternal(boqId, exportName + ' internal-export')
                }else{
                    this.$swal(this.$i18n.t('Export Template'),this.$i18n.t('Template not yet implemented'),'warning')
                }
            }finally{
                this.isExportRunning = false
            }
        }
    }
}
</script>

<style scoped>
.boq-builder-page .hle-boq-builder-table-wrap {
    border-radius: 0 !important;
}
</style>
